export default (() => {
  var u = window.navigator.userAgent
  return {
    isQQ: u.match(/QQ\/([\d\.]+)/),
    isQZ: u.indexOf("Qzone/") !== -1,
    isNfPlus: u.indexOf("NFAPP") > -1,
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  }
})()



// WEBPACK FOOTER //
// ./src/js/platform.js